
import Card from 'vux/src/components/card/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

import { createNamespacedHelpers } from 'vuex'
import { isApp, getQueryVariable } from '@/util/const'
import playIcon from 'static/img/life_jk_home_film@2x.png'

const { mapState, mapActions } = createNamespacedHelpers('xingshan')
const lang = getQueryVariable('lang') || window.localStorage.getItem('lang') || ''

export default {
components: {
Card,
Grid,
GridItem
},
beforeRouteEnter (to, from, next) {
window.document.title = decodeURIComponent(getQueryVariable('title'))
next()
},
data () {
return {
playIcon
}
},
async mounted () {
let module = getQueryVariable('module')
await this.loadVideoList({ module: module })
this.videoList.forEach((item) => {
item._key = this.randomKey
})
},
computed: {
...mapState(['videoList'])
},
methods: {
...mapActions(['loadVideoList']),
randomKey () {
return Math.random().toString(36).substr(2, 15)
},
jump (item, i) {
let url = `${window.location.origin}${window.location.pathname}`
let videoPage = `${url}/#/video-play?src=${encodeURIComponent(item.url)}&title=${encodeURIComponent(item.name)}&lang=${lang}`


if (isApp()) {

window.location.href = item.url
} else {
window.location.href = videoPage
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/videoList.vue